import React, { useState } from 'react';
import produce from 'immer';
import { SvgIconReact } from 'common/components/svg-icon';
import { BehaviorSelector } from 'iron/common/query-builder/query-entry-section/row-types/new-metric-entry/common/behavior-selector';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { RowFilters } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/event-row';
import { MetricEntryBehavior } from 'common/query-builder/query-entry-section/types';
import styles from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/event-row/index.module.styl';
import type { RowProps } from '../catalog';
export function UserBehaviorDefinition(props: RowProps) {
  var _ref, _props$entry$measurem;
  const [isStagingFilter, setIsStagingFilter] = useState(false);
  const updateBehavior = (behavior: MetricEntryBehavior) => {
    props.updateEntry(produce(props.entry, draft => {
      draft.behavior = behavior;
    }));
  };
  return <div className={styles.eventRow} data-sentry-component="UserBehaviorDefinition" data-sentry-source-file="behavior-definition.tsx">
      <div className={styles.header}>
        {/* metric label/selector */}
        <SvgIconReact className={styles.icon} icon='users' data-sentry-element="SvgIconReact" data-sentry-source-file="behavior-definition.tsx" />

        <div className={styles.content}>
          <BehaviorSelector {...props} data-sentry-element="BehaviorSelector" data-sentry-source-file="behavior-definition.tsx" />
        </div>

        <div className={styles.actions}>
          <ButtonReact theme={ButtonTheme.Tertiary} icon='filter-xs' onClick={() => setIsStagingFilter(true)} data-sentry-element="ButtonReact" data-sentry-source-file="behavior-definition.tsx" />
        </div>
      </div>

      {/* renders filters for the behavior event */}
      <div className={styles.filters}>
        <RowFilters {...props} behavior={props.entry.behavior} isStaging={isStagingFilter} dataGroupId={(_ref = (_props$entry$measurem = props.entry.measurement.dataGroupId) !== null && _props$entry$measurem !== void 0 ? _props$entry$measurem : props.entry.behavior.dataGroupId) !== null && _ref !== void 0 ? _ref : props.sectionProps.dataGroupId} onAbortStage={() => setIsStagingFilter(false)} onSelect={updateBehavior} hideEvents data-sentry-element="RowFilters" data-sentry-source-file="behavior-definition.tsx" />
      </div>
    </div>;
}